import React, { Component } from 'react';
import '../styles/Book.css';

class Book extends Component {


  render () {
    let title = this.props.book.volumeInfo.title;
    let url = this.props.book.volumeInfo.imageLinks.thumbnail;
    let author = null;
    if (this.props.book.volumeInfo.authors) author = 'by ' + this.props.book.volumeInfo.authors.join(' & ');

    return(
      <div title='click to pick'className='BookContainer' onClick={() => this.props.selectBook(this.props.book)}>
        <img alt='cover preview' className='BookImage' src={url}/>
        <div className='BookInfo'>
          <p className='title'>{title}</p>
          <p className='author'>{author}</p>
        </div>
        
      </div>
    )
  }
}

export default Book;


// WEBPACK FOOTER //
// ./src/components/Book.js